import { call, put, takeEvery } from 'redux-saga/effects'

import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'

export function* signIn(action) {
  try {
    yield put({ type: 'SIGN_IN_REQUESTED' })

    const request = {
      url: '/authentication',
      body: {
        email: action.payload.formData.email,
        password: action.payload.formData.password,
        query: [
          "id",
          "authentication_token",
          "email"
        ]
      }
    }

    const response = yield call(api.utility.post, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'SIGN_IN_SUCCEEDED'
    })

    const currentUser = response.body;

    const jwtToken = response.headers.map['x-authentication-jwt']

    yield call(sessionHelpers.setApplicationCookie, 'authentication_token', 'Bearer ' + jwtToken)
    yield call(sessionHelpers.setApplicationCookie, 'current_user_id', currentUser.id)
    yield call(sessionHelpers.setApplicationCookie, 'current_user_email', currentUser.email)

    const afterRequestData = {}

    yield call(action.callback, 'success', afterRequestData)

  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'SIGN_IN_FAILED' })

    const afterRequestData = {
      alertMessage: apiErrorHelpers.toString(errors)
    }

    yield call(action.callback, 'failure', afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // signIn()

export function* signOut(action) {
  try {
    yield put({ type: 'SIGN_OUT_REQUESTED' })

    const success = yield call(sessionHelpers.deleteApplicationCookies, ['authentication_token', 'current_user_id', 'current_user_email'])

    // eslint-disable-next-line
    if (success !== true) throw 'Something went wrong'

    yield put({ type: 'SIGN_OUT_SUCCEEDED' })

    yield call(action.callback)
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'SIGN_OUT_FAILED' })

    apiErrorHelpers.consoleLog(errors)
  }
} // signOut()

export default function* sessionSaga() {
  yield takeEvery('SIGN_IN_SAGA', signIn)
  yield takeEvery('SIGN_OUT_SAGA', signOut)
}
